import React from "react";

export const Star = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 0L10.2571 4.89337L15.6085 5.52786L11.6521 9.18663L12.7023 14.4721L8 11.84L3.29772 14.4721L4.34794 9.18663L0.391548 5.52786L5.7429 4.89337L8 0Z"
                fill="#FE9235"
            />
        </svg>
    )
}
